import { lazy, Suspense } from "react";
import useWindowWidth from "../../hooks/useWindowWidth";
import usendLogo from "../../assets/img/usendlogo.png";
import styles from "../styles/signInPreview.module.css";

// three.js loads in its own chunk, after the form is on screen.
const GlobeCanvas = lazy(() =>
  import("../../portals/customer/pages/dashboard/GlobeHero").then((m) => ({ default: m.GlobeCanvas }))
);

// The globe at most 1.1 times the screen height wide, so on tall screens the routes stay
// just below the card instead of near the bottom edge.
const globeSize = (w, h) => Math.min(1.05, (1.1 * h) / w);

export const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

export const MailIcon = () => (
  <Icon>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </Icon>
);

// The badge with the U-Send logo and the card title, shared by every auth card.
export function CardHead({ title, text }) {
  return (
    <>
      <span className={styles.badge}>
        <img src={usendLogo} alt="U-Send" />
      </span>
      <header className={styles.head}>
        <h1>{title}</h1>
        <p>{text}</p>
      </header>
    </>
  );
}

// Login, sign up and password pages in the client preview: a liquid glass card over the
// U-Send globe, which keeps shipping parcels in the background.
export default function AuthGlassShell({ children }) {
  const wide = useWindowWidth() >= 900;
  // Shorter screens leave less room under the card, so the routes sit lower on the globe.
  const globeAngle = !wide ? 60 : window.innerHeight < 1100 ? 52 : 44;

  return (
    <div className={styles.page}>
      <Suspense fallback={null}>
        <GlobeCanvas className={styles.globe} top={wide ? 0.56 : 0.68} size={globeSize} angle={globeAngle} />
      </Suspense>
      <main className={styles.center}>
        {children}

        <footer className={styles.footer}>
          <span>© {new Date().getFullYear()} U-Send</span>
          <a href="/help/privacy" target="_blank" rel="noreferrer">
            Privacy
          </a>
          <a href="/help/terms-and-conditions" target="_blank" rel="noreferrer">
            Terms
          </a>
        </footer>
      </main>
    </div>
  );
}
